import React, { useState } from "react";

import { Button } from "~/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "~/components/ui/sheet";
import { SalesRequest } from "~/types/client";
import { formatCurrency } from "~/utils/helpers";

interface ApproveSheetProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedOrder: SalesRequest;
  clientName: string;
  seller: { name: string; lastname: string };
  isSubmitting: boolean;
  onApprove: () => Promise<void>;
}

export const ApproveSheet: React.FC<ApproveSheetProps> = ({
  isOpen,
  setIsOpen,
  selectedOrder,
  clientName,
  seller,
  isSubmitting,
  onApprove,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleApprove = async () => {
    setIsLoading(true);
    await onApprove();
    setIsOpen(false);
    setIsLoading(false);
  };

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetContent className="sm:max-w-md">
        <SheetHeader>
          <SheetTitle>Aprobar Nota de Venta</SheetTitle>
          <SheetDescription>
            ¿Está seguro que desea aprobar esta nota de venta?
          </SheetDescription>
        </SheetHeader>
        <div className="mt-6 flex flex-col gap-6">
          <div className="grid gap-2">
            <div className="mb-1 font-medium">Información de la Nota</div>
            <div className="grid grid-cols-2 gap-2 text-sm">
              <span className="text-muted-foreground">Cliente:</span>
              <span>{clientName || "Cliente"}</span>
              <span className="text-muted-foreground">Total:</span>
              <span>{formatCurrency(selectedOrder.totalAmount)}</span>
              <span className="text-muted-foreground">Vendedor:</span>
              <span>
                {seller.name} {seller.lastname}
              </span>
            </div>
          </div>
          <div className="mt-4 flex justify-end gap-3">
            <Button
              variant="outline"
              onClick={() => setIsOpen(false)}
              disabled={isSubmitting}
            >
              Cancelar
            </Button>
            <Button
              onClick={handleApprove}
              className="bg-green-600 hover:bg-green-700"
              disabled={isSubmitting || isLoading}
            >
              {isLoading ? "Cargando..." : "Confirmar Aprobación"}
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
